import { useEffect, useState } from "react";
import { userProfileData } from "../../../Common/profileInfo";
import { clientConfig } from "../../../awsClientConfig";
import { GetPartnerAlertsByPartner } from "../../../queries/PartnerAlerts";
import { useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import ExclamationCircle from "../../../assets/exclamation-circle-fill.svg";
import { formatDateShort } from "../../../functions/misc";

export default function AlertBlockTaxFraud(this: any) {
  const client = new clientConfig();
  const navigate = useNavigate();
  const [date, setDate] = useState("");
  const [alertsFound, setAlertsFound] = useState(false);

  useEffect(() => {
    const getPartnerAlertsByPartner = async () => {
      const partnerId = await userProfileData();
      client.query({
        query: GetPartnerAlertsByPartner,
        variables: {
          PartnerId: partnerId,
          AlertType: "TheftMonitoring",
          Limit: 5,
          NextToken: "1"
        }
      })
        .then((res: any) => {
          var responseData = res.data.GetPartnerAlertsByPartner;
          var partnerAlerts = responseData.PartnerAlerts.length;
          var date = responseData.PartnerAlerts[0].CreatedAt;
          setDate(date);
          var alertPartnerId = null;
          if (partnerAlerts !== 0) {
            alertPartnerId = responseData.PartnerAlerts[0].PartnerId;
            setAlertsFound(true);
          }
        });
    };
    getPartnerAlertsByPartner();
  }, []);

  return alertsFound ? (
    <section className="alertBlock">
      <Card className="border-0 w-100">
        <Card.Body>
          <div className="row">
            <div className="col-md-1">
              <img src={ExclamationCircle} className="me-2 material-blue fs-6" alt="Alert" />
            </div>
            <div className="col-md-9">
              <div className="d-block text-danger">
                {'Unauthorized Tax Return Filed for Client(s)!'}
              </div>
              <div className="content-text">
                Please contact them to resolve as soon as possible.&nbsp;
                <a className="pointer" onClick={() => navigate("/partner-referrals")}>
                  View Clients
                </a>
              </div>
            </div>
            <div className="col-md-2">
              <span className="date">
                {formatDateShort(date)}
              </span>
            </div>
          </div>
        </Card.Body>
      </Card>
    </section>
  ) : <></>;
}